export { default } from './transfer-overlay-trigger';
